import styled from 'styled-components/macro';
import { mediaQuery } from '../../../../styles/shared.styles';

export const DialogContentWrapper = styled.div`
  padding: 15px;
  ${mediaQuery.medium} {
    padding: 40px;
  }
`;
